import PageHero from "@/components/layout/PageHero";
import SEO from "@/components/layout/SEO";
import FeatureList from "@/components/layout/FeatureList";
import PremiumForm from "@/components/forms/PremiumForm";
import FinalCTA from "@/components/home/FinalCTA";
import { IMG, BOOKING_URLS } from "@/lib/content";

const ITEMS = [
  { title: "Supervisor search", body: "Identify researchers whose work aligns with yours — and who are actually accepting candidates." },
  { title: "Proposal refinement", body: "Sharpen your research proposal to fit Polish academic expectations without losing your voice." },
  { title: "Program & funding routes", body: "Doctoral schools, NAWA fellowships, university stipends and private funding — mapped honestly." },
  { title: "Interview preparation", body: "What Polish doctoral committees typically ask, and how to prepare for admission and supervisor calls." },
];

export default function PhD() {
  return (
    <div data-testid="page-phd">
      <SEO
        title="PhD in Poland — research strategy & supervisor search"
        description="Tailored guidance for international PhD candidates: supervisor identification, proposal strategy and program fit for Polish doctoral schools."
        path="/phd"
      />
      <PageHero
        overline="PhD in Poland"
        title={<>PhD in Poland — <span className="italic text-[#D7141A]">research fit</span>, not luck.</>}
        subtitle="A tailored path for research candidates: supervisor identification, proposal strategy and program fit for Polish doctoral schools."
        image={IMG.research}
        ctaPrimary={{ to: BOOKING_URLS.phd, label: "Explore PhD Guidance" }}
        ctaSecondary={{ to: "/free-resources", label: "Research Resources" }}
      />
      <FeatureList
        overline="Research strategy"
        title="Built for researchers, not applicants."
        intro="A PhD is a four-year commitment to a person and a project. We help you choose both carefully."
        items={ITEMS}
      />
      <section className="section-pad bg-[#EBE9E1]/60" id="premium" data-testid="phd-premium-form-section">
        <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline">Research strategy form</div>
            <h2 className="font-serif text-3xl sm:text-4xl text-[#0D1B2A] mt-3 leading-tight">Tell us about your research.</h2>
            <p className="text-[#4A5568] mt-5 leading-relaxed">
              Share your research focus and any target universities. We'll review fit honestly, including where you'd be a stronger candidate.
            </p>
          </div>
          <div className="lg:col-span-7">
            <PremiumForm defaultTrack="PhD" testPrefix="phd-premium" />
          </div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
}
